/**
 * RiskLedgerMerchantPickerAgGridHook
 *
 * Merchant picker for /admin/merchants/risk-decision-ledger — that page
 * used to require already knowing a merchant's numeric TID Master ID
 * before it would show anything. This lets the user browse/search
 * instead; picking a row loads that merchant's ledger the same way
 * typing its ID does.
 *
 * Client-side row model, same pattern as TidMasterAgGridHook: rows are
 * pushed in whole (capped server-side, see RiskDecisionLedger's
 * @picker_page_size) rather than paged over the socket, since this is a
 * picker, not a full merchant browser — the search box covers anything
 * outside the default page.
 */

const STATUS_COLORS = {
  active: { bg: "#DCFCE7", color: "#166534" },
  suspended: { bg: "#FEE2E2", color: "#991B1B" },
  terminated: { bg: "#F3F4F6", color: "#374151" },
};

const statusCell = (params) => {
  if (!params.value) return "";
  const meta = STATUS_COLORS[params.value] || { bg: "var(--ag-chip-background-color)", color: "var(--ag-data-color)" };
  return `<span style="background:${meta.bg};color:${meta.color};padding:1px 8px;border-radius:9999px;font-size:11px;font-weight:600;">${params.value}</span>`;
};

const RiskLedgerMerchantPickerAgGridHook = {
  mounted() {
    if (!window.agGrid || !window.agGrid.createGrid) {
      console.error("RiskLedgerMerchantPickerAgGridHook: agGrid not found on window");
      return;
    }

    const columnDefs = [
      { headerName: "Merchant", field: "name", flex: 1.4, minWidth: 200 },
      { headerName: "MID", field: "mid", width: 160 },
      { headerName: "MCC", field: "mcc_code", width: 110 },
      { headerName: "Status", field: "status", width: 120, cellRenderer: statusCell },
    ];

    this.gridApi = window.agGrid.createGrid(this.el, {
      columnDefs,
      rowData: JSON.parse(this.el.dataset.rows || "[]"),
      pagination: true,
      paginationPageSize: 25,
      domLayout: "normal",
      defaultColDef: { resizable: true, sortable: true },
      animateRows: true,
      overlayNoRowsTemplate: `<span style="padding:20px;color:#6B7280;">${this.el.dataset.empty || "No merchants match."}</span>`,
      onRowClicked: (params) => {
        if (params.data) this.pushEvent("pick_merchant", { id: params.data.id });
      },
    });

    this.handleEvent("update_risk_merchant_picker", ({ rows }) => {
      if (this.gridApi) this.gridApi.setGridOption("rowData", rows);
    });
  },

  destroyed() {
    if (this.gridApi) {
      this.gridApi.destroy();
      this.gridApi = null;
    }
  },
};

export default RiskLedgerMerchantPickerAgGridHook;
